import React, { useState, useEffect } from "react";
import TextInput from "../../components/Reusable/TextInput";
import SelectInput from "../../components/Reusable/SelectInput";
import DateInput from "../../components/Reusable/DateInput";
import ProfilePhotoUpload from "../../components/Reusable/ProfilePhotoUpload";
import { useGetAllDepartments } from "../../hooks/useDepartments";
import { useGetAllShiftSchedules } from "../../hooks/useShiftSchedules";
import { useGetAllWorkLocations } from "../../hooks/useWorkLocations";
import {
  useCreateUser,
  useGetAllEmployeesPaginated,
  useGetAllEmploymentStatuses,
  useGetAllJobGrades,
  useGetAllJobPositions,
  useGetEmployeeById,
  useUpdateUser,
} from "../../hooks/useUsers";
import { toast } from "react-toastify";
import {
  EMPLOYEE_PUBLIC_MEDIA_REFERENCE,
  formatDateOnly,
  getEmployeePublicMediaBase64,
  getMediaBase64,
} from "../../util/common";
import { useCreateAdminMedia } from "../../hooks/useMedia";
import { useParams } from "react-router-dom";
import { useGlobal } from "../../contexts/GlobalContext";
import CheckboxInput from "../../components/Reusable/CheckboxInput";
import { useGetAllLeaveTypes } from "../../hooks/useLeave";

function AddUserLayout() {
  const [newUser, setNewUser] = useState({
    EmployeeCode: "",
    UserType: 1,
    Email: "jimboyreyes0@gmail.com",
    Password: "abcd",

    FirstName: "Jimboy",
    MiddleName: "",
    LastName: "Reyes",
    Suffix: "",
    Gender: "Male",
    DateOfBirth: "2000-10-18",
    CivilStatus: "Single",

    ContactNumber: "639217236957",
    AlternateContactNumber: "639665363225",

    Address: "Tambubong",
    City: "San Rafael",
    Province: "Bulacan",
    PostalCode: "3008",
    Country: "Philippines",

    EmploymentTypeID: 1,
    EmploymentStatusID: 1,
    JobStatus: "Direct Employee",
    JobGrade: null,
    JobPosition: null,
    DateHired: "2023-10-18",
    RegularizationDate: "2024-10-18",

    WorkLocationID: 1,
    ShiftScheduleID: 1,
    ReportingToEmployeeID: 1,

    EducationType: "College",
    School: "STI College",
    EducationFromDate: "2000-10-18",
    EducationToDate: "2001-10-18",
    EducationDegree: "Information Technology",

    EmergencyContactName: "Lorna Reyes",
    EmergencyContactRelationship: "Mother",
    EmergencyContactNumber: "639217236957",
    EmergencyContactAddress: "Tambubong San Rafael Bulacan",

    ProfilePictureMediaID: null,

    LeaveTypeIDs: [],
  });

  const [isEditUser, setIsEditUser] = useState(false);
  const [editUserID, setEditUserID] = useState(null);

  const [file, setFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);

  const [departmentRecords, setDepartmentRecords] = useState([]);
  const [shiftScheduleRecords, setShiftScheduleRecords] = useState([]);
  const [workLocationRecords, setWorkLocationRecords] = useState([]);
  const [employeeRecords, setEmployeeRecords] = useState([]);
  const [employmentStatusesRecords, setEmploymentStatusesRecords] = useState(
    []
  );
  const [leaveTypeRecords, setLeaveTypeRecords] = useState([]);
  const [jobPositionRecords, setJobPositionRecords] = useState([]);
  const [jobGradeRecords, setJobGradeRecords] = useState([]);

  const [editedFields, setEditedFields] = useState({});

  const departments = useGetAllDepartments();
  const shiftSchedules = useGetAllShiftSchedules();
  const workLocations = useGetAllWorkLocations();
  const employees = useGetAllEmployeesPaginated();
  const employmentStatuses = useGetAllEmploymentStatuses();
  const leaveTypes = useGetAllLeaveTypes();
  const jobPositions = useGetAllJobPositions();
  const jobGrades = useGetAllJobGrades();

  const _user = useCreateUser();
  const _updateUser = useUpdateUser();
  const mediaUpload = useCreateAdminMedia();
  const getEmployee = useGetEmployeeById();

  const fetchDropdownDatas = async () => {
    departments.mutate(
      {},
      {
        onSuccess: async (result) => {
          if (!result.success) return;

          const records = result.data.map((r) => ({
            id: r.id,
            name: r.Name,
          }));
          setDepartmentRecords(records);
        },
      }
    );
    employmentStatuses.mutate(
      {},
      {
        onSuccess: async (result) => {
          if (!result.success) return;

          const records = result.data.map((r) => ({
            id: r.id,
            name: r.Name,
          }));
          setEmploymentStatusesRecords(records);
        },
      }
    );
    shiftSchedules.mutate(
      {},
      {
        onSuccess: async (result) => {
          if (!result.success) return;

          const records = result.data.map((r) => ({
            id: r.id,
            name: r.Name,
          }));
          setShiftScheduleRecords(records);
        },
      }
    );
    leaveTypes.mutate(
      {},
      {
        onSuccess: async (result) => {
          if (!result.success) return;

          const records = result.data.map((r) => ({
            id: r.id,
            name: r.Name,
          }));
          setLeaveTypeRecords(records);
        },
      }
    );
    workLocations.mutate(
      {},
      {
        onSuccess: async (result) => {
          if (!result.success) return;

          const records = result.data.map((r) => ({
            id: r.id,
            name: r.Name,
          }));
          setWorkLocationRecords(records);
        },
      }
    );

    employees.mutate(
      {
        page: 1,
        pageSize: 150,
      },
      {
        onSuccess: async (result) => {
          if (!result.success) return;

          const records = result.data.data.map((r) => ({
            id: r.id,
            name: r.FullName,
          }));

          setEmployeeRecords(records);
        },
      }
    );
    jobPositions.mutate(
      {},
      {
        onSuccess: async (result) => {
          if (!result.success) return;

          const records = result.data.map((r) => ({
            id: r.id,
            name: `${r.PositionCode} - ${r.PositionTitle}`,
          }));
          setJobPositionRecords(records);
        },
      }
    );
    jobGrades.mutate(
      {},
      {
        onSuccess: async (result) => {
          if (!result.success) return;

          const records = result.data.map((r) => ({
            id: r.id,
            name: `${r.GradeCode} - ${r.GradeName}`,
          }));
          setJobGradeRecords(records);
        },
      }
    );
  };

  const fetchUserDetails = async (id) => {
    getEmployee.mutate(parseInt(id, 10), {
      onSuccess: async (response) => {
        if (response?.success) {
          const { data: userData } = response;

          const {
            ProfilePictureMedia,
            EmploymentStatus,
            ReportingTo,
            ShiftSchedule,
            WorkLocation,
            DateOfBirth,
            DateHired,
            RegularizationDate,
            EducationFromDate,
            EducationToDate,
            JobGradeRecords = [],
            JobPositionRecords = [],
          } = userData;

          const imageFilename = ProfilePictureMedia?.Filename;
          const imageBase64 = imageFilename
            ? await getEmployeePublicMediaBase64(imageFilename, id)
            : null;

          if (imageBase64) {
            setImagePreview(imageBase64);
          }

          const currentJobGrade = JobGradeRecords.find((j) => j.Current);
          const currentJobPosition = JobPositionRecords.find((j) => j.Current);

          setNewUser({
            ...userData,
            EmploymentStatusID: EmploymentStatus?.id ?? null,
            WorkLocationID: WorkLocation?.id ?? null,
            ShiftScheduleID: ShiftSchedule?.id ?? null,
            ReportingToEmployeeID: ReportingTo?.id ?? null,
            DateOfBirth: formatDateOnly(DateOfBirth),
            DateHired: formatDateOnly(DateHired),
            RegularizationDate: formatDateOnly(RegularizationDate),
            EducationFromDate: formatDateOnly(EducationFromDate),
            EducationToDate: formatDateOnly(EducationToDate),
            JobGrade: currentJobGrade?.JobGrade?.id,
            JobPosition: currentJobPosition?.JobPosition?.id,
          });
        }
      },
      onError: (err) => {
        toast.error(err?.response?.data?.message || "Something went wrong");
      },
    });
  };

  useEffect(() => {
    fetchDropdownDatas();
  }, []);

  useEffect(() => {
    if (!newUser.DateHired) return;

    const hiredDate = new Date(newUser.DateHired);
    const regularizationDate = new Date(hiredDate);
    regularizationDate.setMonth(regularizationDate.getMonth() + 6);

    const formattedDate = regularizationDate.toISOString().split("T")[0];

    setNewUser((prev) => ({
      ...prev,
      RegularizationDate: formattedDate,
    }));
  }, [newUser.DateHired]);

  const { id } = useParams();

  useEffect(() => {
    if (id) {
      setIsEditUser(true);
      setEditUserID(id);
      fetchUserDetails(id);
    }
  }, []);

  const handleChange = (field, value) => {
    setNewUser((prev) => ({
      ...prev,
      [field]: value,
    }));

    if (isEditUser) {
      setEditedFields((prev) => ({
        ...prev,
        [field]: value,
      }));
    }
  };

  const handleLeaveTypeChange = (val, checked) => {
    const updatedLeaveTypes = checked
      ? newUser.LeaveTypeIDs.includes(val)
        ? newUser.LeaveTypeIDs
        : [...newUser.LeaveTypeIDs, val]
      : newUser.LeaveTypeIDs.filter((id) => id !== val);

    handleChange("LeaveTypeIDs", updatedLeaveTypes);
  };

  const handleCreateSubmit = async () => {
    _user.mutate(newUser, {
      onSuccess: async (data) => {
        if (data && data.success) {
          const media = await handleFileUpload(data.data.id);
          if (media) {
            const updatedUser = await handleUpdate(data.data.id, {
              ProfilePictureMediaID: media?.id,
            });
            return toast.success(data.message);
          }
          return toast.success(data.message);
        }
      },
      onError: (err) => {
        return toast.error(`${err.response.data.message}`);
      },
    });
  };

  const handleEditSubmit = async () => {
    if (!editUserID) return;

    let payload = { ...editedFields };

    if (file) {
      const media = await handleFileUpload(editUserID);
      if (media) {
        payload.ProfilePictureMediaID = media.id;
      }
    }

    if (Object.keys(payload).length === 0) {
      return toast.info("No changes to update");
    }

    try {
      await handleUpdate(editUserID, payload);
      toast.success("Employee updated successfully");
    } catch {
      toast.error("Failed to update employee");
    }
  };

  const handleSubmit = async () => {
    if (isEditUser) {
      return handleEditSubmit();
    }

    return handleCreateSubmit();
  };

  const handleUpdate = async (employeeID, user) => {
    const data = await _updateUser.mutateAsync({
      id: employeeID,
      userData: user,
    });

    if (data?.success) {
      return data;
    }
  };

  const handleFileUpload = async (employeeID) => {
    if (!file) return null;

    const formData = new FormData();
    formData.append("ReferenceType", EMPLOYEE_PUBLIC_MEDIA_REFERENCE);
    formData.append("AdminMedia", true);
    formData.append("EmployeeID", employeeID);
    formData.append("File", file);

    try {
      const data = await mediaUpload.mutateAsync(formData);
      if (data?.success) {
        return data.data;
      }
    } catch (err) {
      toast.error("File Media Error occurred");
      throw err;
    }
  };

  const isSubmitDisabled = isEditUser && Object.keys(editedFields).length === 0;

  return (
    <div className="add-user-page">
      <div className="form-container">
        <h2>{isEditUser ? "Edit " : "Add "} Employee</h2>
        <form className="add-user-form">
          {/* PERSONAL INFORMATION */}
          <section>
            <h3>Personal Information</h3>
            <ProfilePhotoUpload
              onChange={(val) => {
                setFile(val);
              }}
              imagePreview={imagePreview}
            />
            <div className="form-row">
              <TextInput
                label="First Name"
                placeholder="Juan"
                value={newUser.FirstName}
                onChange={(val) => {
                  handleChange("FirstName", val);
                }}
              />
              <TextInput
                label="Middle Name (Optional)"
                placeholder="Santos"
                value={newUser.MiddleName}
                onChange={(val) => {
                  handleChange("MiddleName", val);
                }}
              />
            </div>

            <div className="form-row">
              <TextInput
                label="Last Name"
                placeholder="Dela Cruz"
                value={newUser.LastName}
                onChange={(val) => {
                  handleChange("LastName", val);
                }}
              />
              <TextInput
                label="Suffix (Optional)"
                placeholder="Jr."
                value={newUser.Suffix}
                onChange={(val) => {
                  handleChange("Suffix", val);
                }}
              />
            </div>

            <div className="form-row">
              <SelectInput
                label="Gender"
                choices={[
                  { id: "Male", name: "Male" },
                  { id: "Female", name: "Female" },
                  { id: "Other", name: "Other" },
                ]}
                value={newUser.Gender}
                onChange={(val) => {
                  handleChange("Gender", val);
                }}
              />
              <DateInput
                label="Birth Date"
                value={newUser.DateOfBirth}
                onChange={(val) => {
                  handleChange("DateOfBirth", val);
                }}
              />
            </div>

            <div className="form-row">
              <TextInput
                label="Contact Number"
                placeholder="+639"
                value={newUser.ContactNumber}
                onChange={(val) => {
                  handleChange("ContactNumber", val);
                }}
              />
              <TextInput
                label="Alternate Contact Number (Optional)"
                placeholder="+639"
                value={newUser.AlternateContactNumber}
                onChange={(val) => {
                  handleChange("AlternateContactNumber", val);
                }}
              />
            </div>
            <TextInput
              label="Email Address"
              placeholder="juandelacruz@gmail.com"
              value={newUser.Email}
              onChange={(val) => {
                handleChange("Email", val);
              }}
            />
            <TextInput
              label="Password"
              placeholder="*********"
              value={newUser.Password}
              onChange={(val) => {
                handleChange("Password", val);
              }}
            />

            <SelectInput
              label="Civil Status"
              choices={[
                { id: "Single", name: "Single" },
                { id: "Married", name: "Married" },
                { id: "Widowed", name: "Widowed" },
                { id: "Divorced", name: "Divorced" },
              ]}
              value={newUser.CivilStatus}
              onChange={(val) => {
                handleChange("CivilStatus", val);
              }}
            />
          </section>

          {/* ADDRESS */}
          <section>
            <h3>Address</h3>
            <TextInput
              label={"Home Number/Street"}
              placeholder="123 Kamagong St."
              value={newUser.Address}
              onChange={(val) => {
                handleChange("Address", val);
              }}
            />

            <div className="form-row">
              <TextInput
                label={"City"}
                placeholder="San Miguel"
                value={newUser.City}
                onChange={(val) => {
                  handleChange("City", val);
                }}
              />

              <TextInput
                label={"Province"}
                placeholder="Zambales"
                value={newUser.Province}
                onChange={(val) => {
                  handleChange("Province", val);
                }}
              />
            </div>

            <div className="form-row">
              <TextInput
                label={"Postal Code"}
                placeholder="1234"
                value={newUser.PostalCode}
                onChange={(val) => {
                  handleChange("PostalCode", val);
                }}
              />
              <TextInput
                label={"Country"}
                placeholder="Philippines"
                value={newUser.Country}
                onChange={(val) => {
                  handleChange("Country", val);
                }}
              />
            </div>
          </section>

          {/* EMPLOYMENT INFORMATION */}
          <section>
            <h3>Employment Information</h3>
            <div className="form-row">
              <SelectInput
                label="Employment Status"
                choices={employmentStatusesRecords}
                value={newUser.EmploymentStatusID}
                onChange={(val) => {
                  handleChange("EmploymentStatusID", parseInt(val));
                }}
              />
              <DateInput
                label="Date Hired"
                value={newUser.DateHired}
                onChange={(val) => {
                  handleChange("DateHired", val);
                }}
              />
              <DateInput
                label="Regularization Date"
                value={newUser.RegularizationDate}
                onChange={(val) => {
                  handleChange("RegularizationDate", val);
                }}
              />
            </div>
            <div className="form-row">
              <SelectInput
                label="Job Status"
                choices={[
                  {
                    id: "Direct Employee",
                    name: "Direct Employee",
                  },
                  {
                    id: "Indirect Employee",
                    name: "Indirect Employee",
                  },
                ]}
                value={newUser.JobStatus}
                onChange={(val) => {
                  handleChange("JobStatus", val);
                }}
              />

              <SelectInput
                label="Job Grade"
                choices={jobGradeRecords}
                value={newUser.JobGrade}
                onChange={(val) => {
                  handleChange("JobGrade", parseInt(val));
                }}
              />
              <SelectInput
                label="Job Position"
                choices={jobPositionRecords}
                value={newUser.JobPosition}
                onChange={(val) => {
                  handleChange("JobPosition", parseInt(val));
                }}
              />
            </div>

            <div className="form-row">
              <SelectInput
                label="Work Location"
                choices={workLocationRecords}
                value={newUser.WorkLocationID}
                onChange={(val) => {
                  handleChange("WorkLocationID", parseInt(val));
                }}
              />
              <SelectInput
                label="Shift Schedule"
                choices={shiftScheduleRecords}
                value={newUser.ShiftScheduleID}
                onChange={(val) => {
                  handleChange("ShiftScheduleID", parseInt(val));
                }}
              />
            </div>
            <div className="form-row">
              <SelectInput
                label="Reporting To"
                choices={employeeRecords}
                value={newUser.ReportingToEmployeeID}
                onChange={(val) => {
                  handleChange("ReportingToEmployeeID", parseInt(val));
                }}
              />
              {/* <SelectInput label="Department" choices={departmentRecords} /> */}
            </div>
          </section>

          {/* LEAVE INFORMATION */}
          {!isEditUser && (
            <section>
              <h3>Leave Information </h3>
              <small>
                After adding, any modification should be made on the Employee
                Leave Credits module.
              </small>
              <div className="form-row">
                {leaveTypeRecords.map((l, index) => (
                  <CheckboxInput
                    label={l.name}
                    val={l.id}
                    checked={newUser.LeaveTypeIDs?.includes(l.id)}
                    onChange={handleLeaveTypeChange}
                    key={index}
                  />
                ))}
              </div>
            </section>
          )}

          {/* EDUCATIONAL BACKGROUND */}
          <section>
            <h3>Educational Background</h3>
            <div className="form-row">
              <SelectInput
                label="Education Type"
                choices={[
                  {
                    id: "High School",
                    name: "High School",
                  },
                  {
                    id: "College",
                    name: "College",
                  },
                  {
                    id: "Vocational",
                    name: "Vocational",
                  },
                  {
                    id: "Post Graduate",
                    name: "Post Graduate",
                  },
                ]}
                value={newUser.EducationType}
                onChange={(val) => {
                  handleChange("EducationType", val);
                }}
              />
              <TextInput
                label={"School"}
                placeholder="Ateneo De Manila University"
                value={newUser.School}
                onChange={(val) => {
                  handleChange("School", val);
                }}
              />
            </div>

            <div className="form-row">
              <DateInput
                label={"From Date"}
                value={newUser.EducationFromDate}
                onChange={(val) => {
                  handleChange("EducationFromDate", val);
                }}
              />
              <DateInput
                label={"To Date"}
                value={newUser.EducationToDate}
                onChange={(val) => {
                  handleChange("EducationToDate", val);
                }}
              />
            </div>
            <TextInput
              label={"Degree"}
              placeholder="Bachelor of Science in Information Technology"
              value={newUser.EducationDegree}
              onChange={(val) => {
                handleChange("EducationDegree", val);
              }}
            />
          </section>

          {/* EMERGENCY CONTACT */}
          <section>
            <h3>Emergency Contact</h3>
            <div className="form-row">
              <TextInput
                label={"Name"}
                placeholder="Juanita Dela Cruz"
                value={newUser.EmergencyContactName}
                onChange={(val) => {
                  handleChange("EmergencyContactName", val);
                }}
              />
              <TextInput
                label={"Relationship"}
                placeholder="Mother"
                value={newUser.EmergencyContactRelationship}
                onChange={(val) => {
                  handleChange("EmergencyContactRelationship", val);
                }}
              />
            </div>

            <TextInput
              label={"Contact Number"}
              placeholder="+639"
              value={newUser.EmergencyContactNumber}
              onChange={(val) => {
                handleChange("EmergencyContactNumber", val);
              }}
            />
            <TextInput
              label={"Contact Address"}
              placeholder="1234 Pilar St., Novaliches, Quezon City"
              value={newUser.EmergencyContactAddress}
              onChange={(val) => {
                handleChange("EmergencyContactAddress", val);
              }}
            />
          </section>

          <div className="form-actions">
            <button
              type="button"
              onClick={(e) => handleSubmit(e)}
              disabled={isSubmitDisabled}
            >
              Submit Employee
            </button>
          </div>
        </form>
      </div>
      {/* {isTransitioning && (
        <div className="transition-overlay">
          <div className="spinner"></div>
        </div>
      )} */}
    </div>
  );
}

export default AddUserLayout;
